// routes.js
import React from "react";
import Dashboard from "Pages/AdministratorDashboard/dashboard";
import {
  ApartmentOutlined,
  BranchesOutlined,
  ExclamationCircleOutlined,
  SafetyCertificateOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

import TrainingAndDevelopment from "Pages/AdministratorDashboard/TrainingAndDevelopement/TrainingAndDevelopement";
import Complaints from "Pages/AdministratorDashboard/Complaints/Complaints";
import Compliance from "Pages/AdministratorDashboard/Compliance/Complaince";
import DocumentsStore from "Pages/AdministratorDashboard/DocumentsStore/DocumentsStore";
import Assets from "Pages/AdministratorDashboard/Assets/Assets";
import JobPostingForm from "Pages/AdministratorDashboard/Hiring/JobPosting/Hiring";
import Report from "Pages/AdministratorDashboard/Report/Report";
import DepAttendance from "./Pages/AdministratorDashboard/Attendence/Attendence";
import TimeOff from "./Pages/AdministratorDashboard/TimeOff";
import Designations from "./Pages/AdministratorDashboard/Organization/Designation/Designation";
import Departments from "./Pages/AdministratorDashboard/Organization/Departments";

import {
  DashboardOutlined,
  FolderOpenOutlined,
  HistoryOutlined,
  TeamOutlined,
  SolutionOutlined,
  AuditOutlined,
  ReadOutlined,
  FileSearchOutlined,
  ToolOutlined,
  ClusterOutlined,
  DeploymentUnitOutlined,
  CarryOutOutlined,
  DollarOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import JobTitles from "./Pages/AdministratorDashboard/Organization/JobTitles";
import EmployeeDirectory from "./Pages/AdministratorDashboard/Organization/Employee/EmployeeDirctory";
import HierarchyView from "./Pages/AdministratorDashboard/Organization/HierarchyView/HierarchyView";
import UserInvite from "./Pages/AdministratorDashboard/UserInvitation/UserInvite";
import Onboarding from "./Pages/AdministratorDashboard/Onboarding/Onboarding";
import PayrollAdmin from "./Pages/AdministratorDashboard/Payroll/PayrollAdmin";
import AdminFlightRisk from "./Pages/AdministratorDashboard/FlightRisk/FlightRisk";

// ---- Utility helpers ----
function safeGetRole() {
  return localStorage.getItem("role")?.trim() || "Admin";
}


function wrapName(name) {
  return name?.length > 18 ? `${name.substring(0, 18)}...` : name;
}

// ---- Base routes (Admin default) ----
const adminRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <DashboardOutlined size="16px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Organization",
    key: "organization",
    icon: <ApartmentOutlined size="16px" />,
    collapse: [
      {
        name: "Departments",
        key: "departments",
        route: "/organization/departments",
        icon: <ClusterOutlined size="16px" />,
        component: <Departments />,
      },
      {
        name: "Job Titles",
        key: "job-titles",
        route: "/organization/job-titles",
        component: <JobTitles />,
        icon: <SolutionOutlined size="16px" />,
      },
      {
        name: "Designations",
        key: "designations",
        route: "/organization/designations",
        icon: <DeploymentUnitOutlined size="16px" />,
        component: <Designations />,
      },
      {
        name: "Employee Directory",
        key: "employee-directory",
        route: "/organization/directory",
        icon: <TeamOutlined size="16px" />,
        component: <EmployeeDirectory />,
      },
      {
        name: "Hierarchy View",
        key: "hierarchy-view",
        route: "/organization/hierarchy",
        icon: <BranchesOutlined size="16px" />,
        component: <HierarchyView />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Document Storage",
    key: "document-store",
    route: "/document-store",
    icon: <FolderOpenOutlined size="16px" />,
    component: <DocumentsStore />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Attendance",
    key: "attendance",
    route: "/attendance",
    icon: <HistoryOutlined size="16px" />,
    component: <DepAttendance />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "TimeOff",
    key: "timeOff",
    route: "/timeoff",
    icon: <CarryOutOutlined size="16px" />,
    component: <TimeOff />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Hiring",
    key: "hiring",
    route: "/hiring",
    icon: <AuditOutlined size="16px" />,
    component: <JobPostingForm />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Onboarding",
    key: "onboarding",
    route: "/onboarding",
    icon: <AuditOutlined size="16px" />,
    component: <Onboarding />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Report",
    key: "report",
    route: "/report",
    icon: <FileSearchOutlined size="16px" />,
    component: <Report />,
    noCollapse: true,
  },
    {
    type: "collapse",
    name: "Training and Development",
    key: "training",
    route: "/training",
    icon: <ReadOutlined size="16px" />,
    component: <TrainingAndDevelopment />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Complaints",
    key: "complaints",
    route: "/complaints",
    icon: <ExclamationCircleOutlined size="16px" />,
    component: <Complaints />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Compliance",
    key: "compliance",
    route: "/compliance",
    icon: <SafetyCertificateOutlined size="16px" />,
    component: <Compliance />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Assets",
    key: "assets",
    route: "/assets",
    icon: <ToolOutlined size="16px" />,
    component: <Assets />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "User Invitation",
    key: "user-invitation",
    route: "/user-invitation",
    icon: <UserAddOutlined size="16px" />,
    component: <UserInvite />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Payroll & Bonuses",
    key: "payroll",
    route: "/payroll",
    icon: <DollarOutlined size="16px" />,
    component: <PayrollAdmin />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Flight Risk",
    key: "flight-risk",
    route: "/flight-risk",
    icon: <WarningOutlined size="16px" />,
    component: <AdminFlightRisk />,
    noCollapse: true,
  },
];

// ---- Dynamic route builder ----
export async function getAdminRoutes() {
  const role = safeGetRole();

  // Only Admin check now
  if (role === "Admin") {
    return adminRoutes.map((r) => ({ ...r, name: wrapName(r.name) }));
  }

  // Non-admin: return nothing or minimal routes if needed
  return [];
}

// Default export: wrapped names
export default adminRoutes.map((r) => ({ ...r, name: wrapName(r.name) }));